import { getGetOrganizationSettingsQueryKey, getOrganizationSettings } from "@fp/admin-api-client/organizations/organizations.client";
import type { QueryClient } from "@tanstack/react-query";
import { redirect, type UseNavigateResult } from "@tanstack/react-router";
import type { AxiosError } from "axios";
import { type ApiErrorResponse, getErrorMessage } from "@/lib/axios";
import { toast } from "@/lib/toast";

export const redirectUnlessPayoutPolicyEnabled = async (queryClient: QueryClient) => {
  const settings = await queryClient.ensureQueryData({
    queryKey: getGetOrganizationSettingsQueryKey(),
    queryFn: () => getOrganizationSettings(),
  });

  if (!settings.data.payoutPolicyEnabled) {
    throw redirect({ to: "/settings" });
  }
};

export const reportPayoutPolicyError = (
  err: AxiosError<ApiErrorResponse>,
  fallback: string,
  queryClient: QueryClient,
  navigate: UseNavigateResult<string>,
) => {
  if (err.response?.data?.code === "PAYOUT_POLICY_NOT_ENABLED") {
    queryClient.invalidateQueries({ queryKey: getGetOrganizationSettingsQueryKey() });
    navigate({ to: "/settings" });
    return;
  }

  toast.error(getErrorMessage(err, fallback));
};